interface ITypeOfCurrency {
  [index: string]: string;
  rub: string;
}

const typeOfCurrency: ITypeOfCurrency = {
  rub: 'руб.',
};

export default typeOfCurrency;
